import { driverPay_source } from "../DCR.dtos";

export const getUnformattedString = (val: string) => {

    if (val && val.trim() !== "") {
        val = val.replace(/-/g, "").replace(/_/g, "").replace(/\//g, "").replace(/,/g, "").replace(/$/g, "").replace(/%/g, "").trim();
    }

    if (!val) {
        val = "";
    }
    return val;
};

export const urlEncode = (strText: string) => {
    return encodeURIComponent(strText).replace(/'/g, "%27").replace(/"/g, "%22");
    //return _.escape(strText);
};

export const urlDecode = (strText: string) => {
    return decodeURIComponent(strText.replace(/\+/g, " "));
};

export const encodeXML = (s: string): string => {
    return s.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
};

export const decodeXML = (s: string): string => {
    s = urlDecode(s)
    return s.replace(/&apos;/g, "'")
        .replace(/&quot;/g, '"')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/&amp;/g, '&');
};

export const encodeForOmni = (s: string) => {
    return encodeURIComponent(encodeXML(s))
};

export const maskAccountNumber = (inp: string): string => { 
    return inp.length > 4 ? inp.replace(/\w(?=\w{4})/g, "X") : inp;
};

export const maskWespathAccountNumber = (inp: string): string => {
    let maskedAcNo = "";
    if (inp) {
        const sec1 = inp.substr(0, 9);
        const sec2 = inp.substr(9, 6);
        const sec3 = inp.substr(15, 2);

        maskedAcNo = [sec1, sec2, sec3].join('/');

    }
    return maskedAcNo;
};

export const checkNullOrUndefined = (value: any): boolean => {
    return value === null || value === undefined;
};

export const getAccountFieldValueByName = (paymentAccount: driverPay_source | null, fieldName: string): string => {
    let returnVal: string | undefined = "";
    if (fieldName?.trim()?.length > 0) {
        if (fieldName.includes("~")) {
            returnVal = paymentAccount?.source_info.find(x => (x.name === fieldName.split("~")[0] || x.name === fieldName.split("~")[1]))?.value;
        }
        else {
            returnVal = paymentAccount?.source_info.find(x => (x.name === fieldName))?.value;
        }
    }
    return returnVal ? decodeURIComponent(returnVal) : "";
};